export default __webpack_public_path__ + "static/media/support_icon.62528763.svg";